import { useEffect, useState } from 'react';
import { api, apiErrorText } from '../api.ts';

const WORDS: Record<string, string> = {
  new_work: 'emails about new work',
  idea_decision: 'emails about decisions on your ideas',
  all: 'notification emails from Setu',
};

/**
 * Where the "stop these emails" link lands. It acts on arrival — nobody wants
 * a second button to confirm they meant it — and offers the way back.
 */
export default function Unsubscribe({ onDone }: { onDone: () => void }): React.ReactElement {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('t') ?? '';
  const kind = params.get('k') ?? '';
  const [state, setState] = useState<'working' | 'off' | 'on' | 'error'>('working');
  const [error, setError] = useState('');

  const set = (resubscribe: boolean) => {
    setState('working');
    api
      .unsubscribe(token, kind, resubscribe)
      .then(() => setState(resubscribe ? 'on' : 'off'))
      .catch((err) => {
        setError(apiErrorText(err));
        setState('error');
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => set(false), []);

  const what = WORDS[kind] ?? 'these emails';

  return (
    <div className="gate">
      <div className="card stack">
        <div className="brand" style={{ paddingLeft: 0 }}>
          <b>Setu</b>
        </div>
        {state === 'working' && <p className="muted">One moment…</p>}
        {state === 'off' && (
          <>
            <h1>Done — no more {what}.</h1>
            <p className="soft">Nothing else changes. Everything still shows up in the app when you open it.</p>
            <div className="row">
              <button className="btn quiet" onClick={() => set(true)}>
                That was a mistake, turn them back on
              </button>
            </div>
          </>
        )}
        {state === 'on' && (
          <>
            <h1>Back on.</h1>
            <p className="soft">You will get {what} again.</p>
          </>
        )}
        {state === 'error' && (
          <p className="notice alert" role="alert">
            {error} You can also change this under “You” in the app.
          </p>
        )}
        {state !== 'working' && (
          <div>
            <button className="linklike" onClick={onDone}>
              Open Setu
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
